"use client"

import { lazy, Suspense } from "react"

import { useLiveChartSeries } from "@shared/ui/hooks/use-live-chart-series"

import type { RiskCardKey } from "@/lib/live-data"

const MiniChart = lazy(() =>
  import("@shared/ui/landing/mini-chart").then((mod) => ({ default: mod.MiniChart })),
)

type RiskCardChartProps = {
  cardKey: RiskCardKey
  score: number
  color: string
}

export function RiskCardChart({ cardKey, score, color }: RiskCardChartProps) {
  const data = useLiveChartSeries(cardKey, {
    points: 10,
    base: score,
    stepAmplitude: 8,
  })

  return (
    <Suspense fallback={<div className="h-32 animate-pulse rounded-lg bg-white/5" />}>
      <MiniChart data={data} type="area" color={color} />
    </Suspense>
  )
}
